import { PaginationContext } from "./context";
import { PageControls } from "./PageControls";
import { PageSizeControls } from "./PageSizeControls";
import type {
  PaginationContext as PaginationContextType,
  PaginationProps,
} from "./types";

export const Pagination = (props: PaginationProps) => {
  const context: PaginationContextType = props;

  return (
    <PaginationContext value={context}>
      <div className="flex items-center gap-8">
        <PageSizeControls />
        <PageControls />
      </div>
    </PaginationContext>
  );
};
